import { Textarea } from '../../../../ui/textarea';
import type { BaseFieldProps, TextAreaFieldSchema } from '../../../types';

export function TextAreaFieldInput({
  field,
  value,
  onChange,
  error,
}: BaseFieldProps<TextAreaFieldSchema, string | null | undefined>) {
  return (
    <Textarea
      id={field.id}
      placeholder={field.placeholder}
      value={value || ''}
      onChange={(e) => onChange?.(e.target.value)}
      className="min-h-[100px]"
      aria-invalid={!!error}
    />
  );
}

export function TextAreaFieldView({
  value,
  viewPlaceholder,
}: BaseFieldProps<TextAreaFieldSchema, string | null | undefined>) {
  if (value === undefined || value === null || value === '') {
    return <span className="text-muted-foreground text-sm">{viewPlaceholder || '- -'}</span>;
  }

  return <p className="text-sm font-medium whitespace-pre-wrap">{value}</p>;
}
